/** @typedef {'waiting' | 'in_chair' | 'done'} PosLineStatus */

/** @type {Record<PosLineStatus, string>} */
export const POS_LINE_STATUS_LABELS = {
  waiting: 'Waiting',
  in_chair: 'In Progress',
  done: 'Done',
}

/** @type {PosLineStatus[]} */
export const POS_LINE_STATUS_ORDER = ['waiting', 'in_chair', 'done']

/**
 * @param {string | null | undefined} status
 */
export function formatLineStatusLabel(status) {
  return POS_LINE_STATUS_LABELS[/** @type {PosLineStatus} */ (status)] ?? 'Waiting'
}

/**
 * @param {PosLineStatus} current
 */
export function nextLineStatus(current) {
  const index = POS_LINE_STATUS_ORDER.indexOf(current)
  if (index < 0 || index >= POS_LINE_STATUS_ORDER.length - 1) {
    return current
  }
  return POS_LINE_STATUS_ORDER[index + 1]
}
